const ProductPromoType = Object.freeze({
	SAMPLING: 'sampling',
	ADDON: 'addon',
	BUY_X_PAY_Y: 'buy_x_pay_y',
	BUY_X_RECEIVE_Y: 'buy_x_receive_y',
	DISCOUNT_ON_X: 'discount_on_x',
	DISCOUNT_AFTER_X: 'discount_after_x',
})

const ProductPromoTypesNames = Object.freeze({
	[ProductPromoType.SAMPLING]: 'Producto de Regalo',
	[ProductPromoType.ADDON]: 'Producto Adicional / Addon',
	[ProductPromoType.BUY_X_PAY_Y]: 'Compra X Paga Y',
	[ProductPromoType.BUY_X_RECEIVE_Y]: 'Compra X Recibe Y',
	[ProductPromoType.DISCOUNT_ON_X]: 'Descuento en la unidad X',
	[ProductPromoType.DISCOUNT_AFTER_X]: 'Descuento después de la unidad X',
})

module.exports = {
	ProductPromoType,
	ProductPromoTypesNames,
}

